import { useEffect } from "react";
import { lockBodyScroll, unlockBodyScroll } from "@/shared/lib/bodyScrollLock";

/**
 * `shared/lib/bodyScrollLock` ref-count 코어를 컴포넌트에 연결하는 얇은 훅.
 * `isOpen` 이 true 인 동안 body scroll 을 잠그고, false 로 바뀌거나 언마운트되면 해제한다.
 * lock/unlock 이 항상 짝을 이루는 균형 형태라 StrictMode 이중 호출에도 카운트가 누수되지 않는다.
 */
export function useBodyScrollLock(isOpen: boolean): void {
  useEffect(() => {
    if (!isOpen) return;
    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [isOpen]);
}
